import { useState, useEffect, useRef } from 'react';
import {
  Button,
  ClickAwayListener,
  MenuItem,
  Menu,
  MenuList
} from '@material-ui/core';
import Icon from 'components/base/Icon';
import { StyledButtonGroup } from './ButtonListToggler.style';

const MultiOptionsPicker = ({ options = [], onChange, value }) => {
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const isSelected = value === selectedOption?.value;

  const optionsWithoutSelected = options.filter(
    option => option?.value !== selectedOption?.value
  );

  const shouldDisplayComponent = !!options.length;
  const shouldDisplayMenuToggler = !!optionsWithoutSelected?.length;

  const handleClick = () => {
    onChange(selectedOption);
  };

  const onMenuItemClick = selectedOption => {
    setSelectedOption(selectedOption);
    setOpen(false);
    onChange(selectedOption);
  };

  const handleToggle = () => setOpen(prevOpen => !prevOpen);

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return;
    setOpen(false);
  };

  const checkIfSelectedOptionExists = () => {
    const optionsValues = options.map(option => option?.value);
    const isSelectedOptionNotExists = !optionsValues.includes(
      selectedOption?.value
    );
    if (isSelectedOptionNotExists && options[0]) setSelectedOption(options[0]);
  };

  useEffect(() => {
    checkIfSelectedOptionExists();
  }, [options]);

  useEffect(() => {
    setSelectedOption(options[0]);
  }, [options.length]);

  if (!shouldDisplayComponent) return null;

  return (
    <div className='flex flex-row gap-3'>
      <StyledButtonGroup
        variant={isSelected ? 'contained' : 'outlined'}
        disableElevation
        disableFocusRipple
        innerRef={anchorRef}
      >
        <Button onClick={handleClick} className='btn-selected'>
          {selectedOption?.name}
        </Button>
        {shouldDisplayMenuToggler && (
          <Button onClick={handleToggle} className='btn-selected'>
            <Icon
              name='ArrowDropDown'
              {...(isSelected && { color: 'white' })}
            />
          </Button>
        )}
      </StyledButtonGroup>
      <Menu
        anchorEl={anchorRef.current}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        PaperProps={{
          style: {
            minWidth: '16.5rem'
          }
        }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <MenuList
            id='split-button-menu'
            autoFocusItem
            style={{
              paddingTop: '0',
              paddingBottom: '0'
            }}
          >
            {optionsWithoutSelected.map(option => (
              <MenuItem
                key={option?.value}
                onClick={() => onMenuItemClick(option)}
                style={{ paddingBottom: '1rem' }}
              >
                {option?.name}
              </MenuItem>
            ))}
          </MenuList>
        </ClickAwayListener>
      </Menu>
    </div>
  );
};

export default MultiOptionsPicker;
